import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Layout from './Layout';
import UserManagement from './components/UserManagement';
import HolidayManagement from './components/HolidayManagement';
import Dashboard from './components/Dashboard';

const Configuracion = () => <h2>Configuración de la Cuenta</h2>;

function App() {
    return (
        <ThemeProvider>
            <Authenticator hideSignUp={true}>
                {({ signOut, user }) => (
                    <Layout signOut={signOut}>
                        <Routes>
                            <Route path="/" element={<Dashboard user={user} />} />
                            <Route path="/clientes" element={<UserManagement />} />
                            <Route path="/festivos" element={<HolidayManagement />} />
                            <Route path="/configuracion" element={<Configuracion />} />
                        </Routes>
                    </Layout>
                )}
            </Authenticator>
        </ThemeProvider>
    );
}

export default App;